const PageBody = ({
  instagram,
  instagramUrl,
  body,
  facebook,
  facebookUrl,
  twitter,
  twitterUrl,
  linkedin,
  linkedinUrl,
  email,
  phone,
}) => {
  const hasContacts = instagram || facebook || twitter || linkedin || phone || email;
  const hasBody = Array.isArray(body) && body.length > 0;

  // Don't render the section if nothing is available
  if (!hasContacts && !hasBody) return null;

  return (
    <section onContextMenu={(e) => e.preventDefault()}>
      <div className="container mt-0">
        <div className="row justify-content-center g-4">

			
		  {/* ✅ Body Content (Rich Text) */}
          {hasBody &&
            body.map((block, index) =>
              block.type === "paragraph" ? (
                <div className="col-12" key={index}>
                  <p className="lead display-6 text-dark mb-0 mt-0" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    {block.children?.map((child, i) => (
                      <span key={i}>{child.text}</span>
                    ))}
                  </p>
                </div>
              ) : null
            )}


          {/* ✅ Social Contacts */}
          {hasContacts && (
            <div className="col-12">
              <ol className="list-group list-group-separated">
                {instagram && (
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <span><p className="lead mt-0 text-uppercase">Instagram</p></span>
                    <a href={instagramUrl} target="_blank" className="lead mt-0 text-uppercase text-black">@{instagram}</a>
                  </li>
                )}
                {linkedin && (
                  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                    <span><p className="lead mt-0 text-uppercase">LinkedIn</p></span>
                    <a href={linkedinUrl} target="_blank" className="lead mt-0 text-uppercase text-black">@{linkedin}</a>
                  </li>
                )}
                {twitter && (
                  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                    <span><p className="lead mt-0 text-uppercase">Twitter</p></span>
                    <a href={twitterUrl} target="_blank" className="lead mt-0 text-uppercase text-black">@{twitter}</a>
                  </li>
                )}
                {facebook && (
                  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                    <span><p className="lead mt-0 text-uppercase">Facebook</p></span>
                    <a href={facebookUrl} target="_blank" className="lead mt-0 text-uppercase text-black">{facebook}</a>
                  </li>
                )}
                {email && (
                  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                    <span><p className="lead mt-0 text-uppercase">Email</p></span>
                    <p className="lead mt-0 text-uppercase text-black text-black">{email}</p>
                  </li>
                )}
                {phone && (
                  <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                    <span><p className="lead mt-0 text-uppercase">TLF</p></span>
                    <p className="lead mt-0 text-uppercase text-black text-black">{phone}</p>
                  </li>
                )}

              </ol>
            </div>
          )}

          
        </div>
      </div>
    </section>
  );
};

export default PageBody;
